import RequestAccess from './container';

export default RequestAccess;
